import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Reactour from 'reactour'

export default class Tour extends Component {
  static propTypes = {
    runTour: PropTypes.bool.isRequired,
    tourSteps: PropTypes.array.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  }

  render() {
    const { onRequestClose, runTour, tourSteps } = this.props

    return (
      <Reactour
        disableInteraction={false}
        isOpen={runTour}
        onRequestClose={onRequestClose}
        scrollDuration={3}
        steps={tourSteps}
        lastStepNextButton="Done"
        nextButton={
          <span className="tour-next">
            NEXT <i className="fal fa-caret-right" />
          </span>
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/renderPropComponents/Tour.js